import React from "react";
import LegalLayout from "../components/LegalLayout";

/**
 * Terms of Service stub. Plain-language. Have counsel review before
 * promoting widely.
 */
const SECTIONS = [
    {
        heading: "the agreement",
        body: [
            "By using MoodCard you agree to these Terms. MoodCard is operated by Zephiron Group LLC, a Wyoming, USA limited liability company (\"Zephiron\", \"we\"). If you don't agree with any part of these Terms, please don't use the service.",
        ],
    },
    {
        heading: "what MoodCard is",
        body: [
            "MoodCard turns short text into shareable cards. We use a language model to generate the card text and a visual template to render the result. We make no claim that the output is therapeutic, medical, or factually accurate — it's a creative tool.",
        ],
    },
    {
        heading: "your account",
        body: [
            "You may use the basic service anonymously. You may also sign in with Google or Apple. You're responsible for keeping your sign-in credentials secure with those providers.",
            "You must be at least 13 years old to use MoodCard.",
        ],
    },
    {
        heading: "your content",
        body: [
            "You own the text you submit. By submitting it, you grant Zephiron a worldwide, non-exclusive license to use it solely to generate cards for you, to display your card history, and to share cards on links you choose to share.",
            "You retain full rights to the cards you create. You can post them anywhere.",
            "Don't submit anything that violates the law, infringes someone else's rights, harasses anyone, or is sexually explicit involving minors. We reserve the right to remove content that does.",
        ],
    },
    {
        heading: "premium and payments",
        body: [
            "Optional paid plans (Plus, Premium, Creator) unlock additional materials, premium visual packs, and higher generation limits. Payments are processed by Stripe.",
            "Subscriptions auto-renew unless cancelled. Cancel any time in your account dashboard — you keep premium features until the end of the current billing period.",
            "Refunds: we'll honor refund requests made within 14 days of purchase if you haven't substantially used the premium features. Email hello@moodcard.app.",
        ],
    },
    {
        heading: "service availability",
        body: [
            "We provide MoodCard \"as is\". We don't guarantee uninterrupted service. We may add, remove, or change features at any time.",
            "If we discontinue the service entirely, we'll give signed-in users at least 30 days notice and provide a way to export your cards.",
        ],
    },
    {
        heading: "things we can't be liable for",
        body: [
            "To the maximum extent permitted by law, Zephiron is not liable for indirect, incidental, or consequential damages from use of the service. Our maximum aggregate liability is limited to the greater of (a) the amounts you paid us in the prior 12 months, or (b) USD 50.",
        ],
    },
    {
        heading: "termination",
        body: [
            "You can stop using MoodCard at any time. We can terminate or restrict access if you violate these Terms.",
        ],
    },
    {
        heading: "governing law",
        body: [
            "These Terms are governed by the laws of the State of Wyoming, USA, without regard to its conflict-of-laws provisions. Disputes are resolved in the courts of Wyoming.",
        ],
    },
    {
        heading: "changes to these terms",
        body: [
            "We may update these Terms occasionally. We'll update the \"last updated\" date above and notify signed-in users by email for material changes.",
        ],
    },
    {
        heading: "contact",
        body: [
            "Zephiron Group LLC — Wyoming, USA. Reach us at hello@moodcard.app.",
        ],
    },
];

export default function Terms() {
    return (
        <LegalLayout
            title="Terms of Service"
            subtitle="the rules of this quiet place"
            lastUpdated="March 4, 2026"
            sections={SECTIONS}
            testid="terms-screen"
        />
    );
}
